export const ELoggerNamespaceShared = {
  GLOBAL: 'GLOBAL',
  WARNING: 'WARNING',
  MUTEX: 'MUTEX',

  APP_INIT: 'APP_INIT',
  APP_SHUTDOWN: 'APP_SHUTDOWN',

  SERVICE_FS: 'SERVICE_FS',
  PERFORMANCE_CAPTURE: 'PERFORMANCE_CAPTURE',

  CLIENT_TO_SERVER: 'CLIENT_TO_SERVER',
  SERVER_TO_CLIENT: 'SERVER_TO_CLIENT',

  SERVER_TO_GENERATOR: 'SERVER_TO_GENERATOR',
  GENERATOR_TO_SERVER: 'GENERATOR_TO_SERVER',
};
